<template>
  <section class="octobus__section error">
    <div :class="{ 'octobus__container': !isFullWidth }">
      <div class="octobus__columns content">
        <div class="octobus__column has-text-centered is-size-4" v-html="$t('errorPay.reject')"></div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'Error',
  computed: {
    isFullWidth() {
      return this.$fullwidth;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Error.vue